import type { Ref } from "react"
import Juggling from "./Juggling"

type Props = {
  ref?: Ref<HTMLDivElement>
  size?: number
}

export default function JugglingBig({ ref, size = 120 }: Props) {
  return (
    <div ref={ref} className="flex items-center justify-center p-10">
      <Juggling size={size} />
    </div>
  )
}
